import { render } from "./ButtonDefault.vue?vue&type=template&id=32a13d8f&scoped=true"
import script from "./ButtonDefault.vue?vue&type=script&lang=js"
export * from "./ButtonDefault.vue?vue&type=script&lang=js"

import "./ButtonDefault.vue?vue&type=style&index=0&id=32a13d8f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a13d8f"]])

export default __exports__